<!--
  Partner can update the rides of partner caller
-->
<template>
  <card-container
    :id="pageId"
    :class="pageId"
    :disabled="!isPhoneNumberValid || isLoading"
    :is-loading="isLoading"
    loading-message="Updating Customer Rides..."
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Update Customer Rides
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Phone Number* </label>
        <phone-number-input
          v-model="phoneNumber"
          class="col-sm-8"
          :page-id="pageId"
          :required="true"
        />
      </div>

      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Rides </label>
        <div class="col-sm-8">
          <number-input
            v-model="rides"
            min="0"
            type="number"
            step="1"
            class="form-control"
          />
        </div>
      </div>
    </template>

    <template #submit-button>
      Update
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, computed, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { usePartner } from '@/use/partner';
import { partnerCallerService } from '@/services/partnerCaller';

const pageId = 'update-customer-rides';

export default {
  name: 'UpdateCustomerRides',

  setup: () => {
    const { customerInfo } = useCustomer();
    const { partnerCode } = usePartner();
    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const phoneNumber = ref('');
    const rides = ref('');
    const isLoading = ref(false);

    const isPhoneNumberValid = computed(() => {
      return util.isPhoneNumberValid(phoneNumber.value);
    });

    const submitForm = async () => {
      isLoading.value = true;
      try {
        await partnerCallerService.updatePartnerCaller({
          partnerCode: partnerCode.value,
          phoneNumber: phoneNumber.value,
          data: {
            rides: Number(rides.value),
          },
        });

        showSuccessPopupDialog({
          text: 'The rides have been updated successfully!',
        });
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      phoneNumber.value = customerInfo.value?.phoneNumber || '';
      rides.value = '';
    };

    watch(customerInfo, resetForm, {
      immediate: true,
    });

    return {
      pageId,
      phoneNumber,
      rides,
      isLoading,
      isPhoneNumberValid,

      submitForm,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
.update-customer-rides {
  .el-input__inner {
    color: #000;
  }
}
</style>
